import { Component, input } from '@angular/core';

type IconType = 'password' | 'email' | 'telegram' | 'phone' | 'sms' | 'facebook' | 'google' | 'close' | 'edit'
  | 'check-circle' | 'map' | 'search' | 'trash' | 'ellipsis' | 'heart';

@Component({
  selector: 'tc-icon',
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent {
  iconType = input.required<IconType>();
}
